import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { LightIcon } from "../../../shared/icons";
import { emptyStateStyles } from "./empty-state.styles";

interface EmptyStateProps {
  title: string;
  suggestions: JSX.Element[];
}

export const EmptyState = (props: EmptyStateProps) => {
  const { suggestions, title } = props;
  const styles = emptyStateStyles();

  return (
    <>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Typography className={styles.title} data-testid="title">
          {title}
        </Typography>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Typography className={styles.suggestionTitle}>
          <LightIcon /> Suggestions
        </Typography>
        {suggestions.map((suggestion) => suggestion)}
      </Grid>
    </>
  );
};
